import { installmentText } from "@/lib/pricing";
import { deliveryLine, getDelivery } from "@/lib/delivery";


export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";
export const WHATSAPP_DISPLAY = "(35) 99702-1717";

export const STORE_INFO = {
  city: "Areado - MG",
  serviceNote: "Atendimento e vendas online",
  schedule: [
    { label: "Seg a Sex", days: [1, 2, 3, 4, 5], open: "08:00", close: "21:00" },
    { label: "Sáb e Dom", days: [6, 0], open: "10:00", close: "18:00" },
  ],
  instagram: "rciphoness",
  instagramUrl: "https://www.instagram.com/rciphoness/",
};

const WEEKDAYS = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];
const toMin = (t) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3));
const dayRule = (d) => STORE_INFO.schedule.find((r) => r.days.includes(d));
const brNow = () => {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: "America/Sao_Paulo", weekday: "short", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(new Date())
    .reduce((acc, p) => ({ ...acc, [p.type]: p.value }), {});
  const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(parts.weekday);
  return { day, min: Number(parts.hour) * 60 + Number(parts.minute) };
};

export const storeStatus = () => {
  const { day, min } = brNow();
  const today = dayRule(day);
  if (today && min >= toMin(today.open) && min < toMin(today.close)) {
    return { open: true, text: `Aberto agora · fecha às ${today.close}` };
  }
  if (today && min < toMin(today.open)) return { open: false, text: `Fechado · abre hoje às ${today.open}` };
  for (let i = 1; i <= 7; i += 1) {
    const d = (day + i) % 7;
    const r = dayRule(d);
    if (r) return { open: false, text: `Fechado · abre ${i === 1 ? "amanhã" : WEEKDAYS[d]} às ${r.open}` };
  }
  return { open: false, text: "Fechado" };
};

export const CATEGORIES = [
  { id: "iphone", label: "iPhone", plural: "iPhones" },
  { id: "macbook", label: "MacBook", plural: "MacBooks" },
  { id: "ipad", label: "iPad", plural: "iPads" },
  { id: "watch", label: "Apple Watch", plural: "Apple Watch" },
  { id: "airpods", label: "AirPods", plural: "AirPods" },
  { id: "acessorios", label: "HPrime", plural: "acessórios HPrime" },
];
export const categoryOf = (p) => p?.category || "iphone";

export const IPHONE_MODELS = [
  "iPhone 11", "iPhone 11 Pro", "iPhone 11 Pro Max", "iPhone 12", "iPhone 12 mini", "iPhone 12 Pro", "iPhone 12 Pro Max",
  "iPhone 13", "iPhone 13 mini", "iPhone 13 Pro", "iPhone 13 Pro Max", "iPhone 14", "iPhone 14 Plus", "iPhone 14 Pro", "iPhone 14 Pro Max",
  "iPhone 15", "iPhone 15 Plus", "iPhone 15 Pro", "iPhone 15 Pro Max", "iPhone 16e", "iPhone 16", "iPhone 16 Plus", "iPhone 16 Pro", "iPhone 16 Pro Max",
  "iPhone 17", "iPhone 17 Air", "iPhone 17 Pro", "iPhone 17 Pro Max", "iPhone 18 Pro", "iPhone 18 Pro Max",
];
export const ACC_TYPES = [
  { id: "capa", label: "Capas", single: "Capa" },
  { id: "pelicula", label: "Películas", single: "Película" },
  { id: "fonte", label: "Fontes", single: "Fonte" },
  { id: "cabo", label: "Cabos", single: "Cabo" },
  { id: "loop", label: "Loop Charger", single: "Loop Charger" },
];
export const WATTS = ["20W", "40W", "65W"];
const PRO17 = ["Laranja-cósmico", "Azul-intenso", "Prata"];
const PRO16 = ["Titânio-preto", "Titânio-branco", "Titânio-natural", "Titânio-deserto"];
const PRO15 = ["Titânio-preto", "Titânio-branco", "Titânio-azul", "Titânio-natural"];
const PRO14 = ["Preto-espacial", "Prateado", "Dourado", "Roxo-profundo"];
const PRO13 = ["Grafite", "Dourado", "Prateado", "Azul-sierra", "Verde-alpino"];
const PRO18 = ["Preto", "Prateado", "Glacial", "Bordô"];
const S128 = ["128GB", "256GB", "512GB"];
const S128T = ["128GB", "256GB", "512GB", "1TB"];
const S256T = ["256GB", "512GB", "1TB"];
// Do mais antigo ao mais novo; sealed = pode ser encomendado Novo • Lacrado.
export const IPHONE_SPECS = {
  "iPhone 13": { storages: S128, colors: ["Meia-noite", "Estelar", "Azul", "Rosa", "Verde", "Vermelho"] },
  "iPhone 13 Pro": { storages: S128T, colors: PRO13 },
  "iPhone 13 Pro Max": { storages: S128T, colors: PRO13 },
  "iPhone 14": { storages: S128, colors: ["Meia-noite", "Estelar", "Azul", "Roxo", "Amarelo", "Vermelho"] },
  "iPhone 14 Pro": { storages: S128T, colors: PRO14 },
  "iPhone 14 Pro Max": { storages: S128T, colors: PRO14 },
  "iPhone 15": { storages: S128, colors: ["Preto", "Azul", "Verde", "Amarelo", "Rosa"] },
  "iPhone 15 Pro": { storages: S128T, colors: PRO15 },
  "iPhone 15 Pro Max": { storages: S256T, colors: PRO15 },
  "iPhone 16": { storages: S128, colors: ["Preto", "Branco", "Rosa", "Verde-acinzentado", "Ultramarino"], sealed: true },
  "iPhone 16 Pro": { storages: S128T, colors: PRO16 },
  "iPhone 16 Pro Max": { storages: S256T, colors: PRO16 },
  "iPhone 17": { storages: ["256GB", "512GB"], colors: ["Preto", "Branco", "Azul-névoa", "Sálvia", "Lavanda"], sealed: true },
  "iPhone 17 Air": { storages: S256T, colors: ["Preto-espacial", "Branco-nuvem", "Dourado-claro", "Azul-céu"], sealed: true },
  "iPhone 17 Pro": { storages: S256T, colors: PRO17, sealed: true },
  "iPhone 17 Pro Max": { storages: ["256GB", "512GB", "1TB", "2TB"], colors: PRO17, sealed: true },
  "iPhone 18 Pro": { storages: ["256GB", "512GB", "1TB", "2TB"], colors: PRO18, sealed: true },
  "iPhone 18 Pro Max": { storages: ["256GB", "512GB", "1TB", "2TB"], colors: PRO18, sealed: true },
};
export const MODELS = {
  iphone: Object.keys(IPHONE_SPECS),
  macbook: ["MacBook Air M2", "MacBook Air M3", "MacBook Air M4", "MacBook Pro 14\"", "MacBook Pro 16\""],
  ipad: ["iPad", "iPad mini", "iPad Air", "iPad Pro 11\"", "iPad Pro 13\""],
  watch: ["Apple Watch SE", "Apple Watch Series 10", "Apple Watch Series 11", "Apple Watch Ultra 2", "Apple Watch Ultra 3"],
  airpods: ["AirPods 4", "AirPods 4 com Cancelamento de Ruído", "AirPods Pro 2 (USB-C)", "AirPods Pro 3", "AirPods Max (USB-C)"],
  acessorios: ["Capa MagSafe HPrime", "Película HPrime", "Fonte HPrime", "Cabo HPrime", "Loop Charger HPrime"],
};
export const ORDER_DELIVERY = "Aparelhos por encomenda são entregues em até 7 dias corridos ou devolvemos seu dinheiro.";

export const textKey = (s = "") => String(s).normalize("NFKC").replace(/\s+/g, " ").trim().toLowerCase();
export const storageKey = (s = "") => textKey(s).replace(/\s/g, "");
export const iphoneSpecFor = (model) => IPHONE_SPECS[Object.keys(IPHONE_SPECS).find((k) => textKey(k) === textKey(model))] || null;
export const newOptionsFor = (model) => {
  const spec = iphoneSpecFor(model);
  return spec?.sealed ? spec : null;
};
export const ORDER_STORAGES = ["128GB", "256GB", "512GB", "1TB", "2TB"];
export const orderStoragesFor = (category, model) => (category === "iphone" ? iphoneSpecFor(model)?.storages : null) || ORDER_STORAGES;
const STORAGE_RANK = ["32gb", "64gb", "128gb", "256gb", "512gb", "1tb", "2tb"];
const modelRank = (m = "") => {
  const s = m.toLowerCase();
  const gen = Number(s.match(/\d+/)?.[0] || (/\bx[rs]?\b/.test(s) ? 10 : 0));
  const tier = /pro\s*max/.test(s) ? 0 : /pro/.test(s) ? 1 : /air/.test(s) ? 2 : /plus/.test(s) ? 3 : /mini/.test(s) ? 5 : /\d+e\b/.test(s) ? 6 : 4;
  return { gen, tier };
};
export const byModel = (a, b) => {
  if (isNewCond(a.condition) !== isNewCond(b.condition)) return isNewCond(a.condition) ? -1 : 1;
  const x = modelRank(a.model);
  const y = modelRank(b.model);
  return y.gen - x.gen || x.tier - y.tier
    || STORAGE_RANK.indexOf(storageKey(a.storage)) - STORAGE_RANK.indexOf(storageKey(b.storage));
};

export const PARTS = [
  { id: "bateria", label: "Bateria" },
  { id: "camera_frontal", label: "Câmera Frontal" },
  { id: "camera_traseira", label: "Câmera Traseira" },
  { id: "tela", label: "Tela" },
];
export const partLabel = (id) => PARTS.find((d) => d.id === id)?.label || (id === "camera" ? "Câmera" : id);
export const CONNECTORS = [
  { id: "lightning", label: "Lightning (iPhone 14 ou anterior)" },
  { id: "usbc", label: "USB-C (iPhone 15 ou mais novo)" },
];
export const isCable = (p) => ["cabo", "loop"].includes(accTypeOf(p));
export const cableConnector = (p) => {
  if (p?.connector) return p.connector;
  const n = p?.model || "";
  if (/lightning/i.test(n)) return "lightning";
  if (/tipo[\s-]*c|usb[\s-]*c/i.test(n)) return "usbc";
  return "";
};
export const iphonePort = (model = "") => {
  const n = Number(String(model).match(/iphone\s*(\d+)/i)?.[1] || 0);
  return n >= 15 ? "usbc" : "lightning";
};
const ACC_ORDER = ["pelicula", "capa", "fonte", "cabo", "loop"];
export const fitsIphone = (a, model) => {
  if (usesModels(accTypeOf(a))) return Array.isArray(a?.compatible) && a.compatible.some((m) => textKey(m) === textKey(model));
  if (isCable(a)) return cableConnector(a) === iphonePort(model);
  return true;
};
export const accessoriesFor = (all, model, limit = 8) => (Array.isArray(all) ? all : [])
  .filter((a) => categoryOf(a) === "acessorios" && a.status === "disponivel" && fitsIphone(a, model))
  .filter((a, i, arr) => arr.findIndex((x) => textKey(x.model) === textKey(a.model)) === i)
  .sort((x, y) => ACC_ORDER.indexOf(accTypeOf(x)) - ACC_ORDER.indexOf(accTypeOf(y)))
  .slice(0, limit);
export const usesModels = (type) => type === "capa" || type === "pelicula";
export const accTypeOf = (p) => {
  if (p?.acc_type) return p.acc_type;
  const n = p?.model || "";
  if (/capa/i.test(n)) return "capa";
  if (/pel[ií]cula/i.test(n)) return "pelicula";
  if (/fonte|carregador/i.test(n)) return "fonte";
  if (/cabo/i.test(n)) return "cabo";
  if (/loop/i.test(n)) return "loop";
  return "";
};
export const accDetails = (p) => {
  const t = accTypeOf(p);
  return [p?.color, t === "fonte" ? p?.wattage : null];
};
// Configurações extras de Mac, iPad e Apple Watch (o modelo já traz tamanho; GB e cor têm campo próprio).
export const extraSpecs = (p) => {
  const s = p?.specs || {};
  return [s.chip && `Chip ${s.chip}`, s.ram && `${s.ram} de memória`, s.material && `Caixa de ${s.material.toLowerCase()}`, s.connectivity, s.format].filter(Boolean);
};

// Garantia Apple informada pelo lojista ("2027-05-20" -> "20/05/2027"); vazia se não tiver ou já venceu.
export const appleUntil = (p) => {
  const d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(p?.apple_warranty_until || "");
  if (!d || new Date(`${p.apple_warranty_until}T23:59:59`) < new Date()) return "";
  return `${d[3]}/${d[2]}/${d[1]}`;
};

export const warrantyOf = (p) => {
  if (categoryOf(p) === "acessorios") {
    const t = accTypeOf(p);
    const long = p?.warranty ? p.warranty === "3anos" : t === "fonte" || t === "cabo";
    return long ? "3 anos de garantia" : "3 meses de garantia contra defeitos de fábrica";
  }
  // Com garantia Apple ativa (data informada no cadastro) ela substitui a garantia padrão; vencida, volta a padrão.
  if (appleUntil(p)) return `Garantia Apple até ${appleUntil(p)}`;
  return isNewCond(p?.condition) ? "1 ano de garantia Apple" : "4 meses de garantia";
};

export const NEW_SEALED = "Novo • Lacrado (Americano)";
export const NEW_ANATEL = "Novo • Lacrado (Anatel)";
export const ORDER_NEW = "Novo • Lacrado";
export const isNewCond = (c) => c === "novo" || c === "anatel";
export const isUSNew = (p) => p?.condition === "novo" && categoryOf(p) !== "acessorios";
export const conditionLabel = (p) => (p?.condition === "anatel" ? NEW_ANATEL : isUSNew(p) ? NEW_SEALED : p?.condition === "novo" ? "Novo" : "Seminovo");

const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export const formatPrice = (price) => (Number(price) > 0 ? brl.format(Number(price)) : "Sob consulta");

export const waLink = (message) => {
  const delivery = deliveryLine(getDelivery());
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(delivery ? `${message}\n${delivery}` : message)}`;
};

export const GENERAL_MESSAGE = "Olá, RC iPhones! Vi o site e quero saber mais sobre os aparelhos disponíveis.";

export const offerMessage = (p) => productMessage(p).replace("Tenho interesse no", "Vi a Oferta da semana e tenho interesse no");
export const baseMessage = (p) => (p?._offer ? offerMessage(p) : productMessage(p));

export const productMessage = (p, forModel = "", pay = "") => {
  const cond = conditionLabel(p);
  const isAcc = categoryOf(p) === "acessorios";
  const details = (isAcc ? accDetails(p) : [p?.storage, ...extraSpecs(p), p?.color, cond, p?.battery != null ? `bateria ${p.battery}%` : null, appleUntil(p) ? `garantia Apple até ${appleUntil(p)}` : null]).filter(Boolean).join(", ");
  const price = Number(p?.price) > 0 ? ` por ${formatPrice(p.price)}` : "";
  const inst = installmentText(p);
  const parcel = pay ? `. Quero pagar *${pay}*` : inst ? ` (ou ${inst})` : "";
  const forTxt = isAcc && forModel ? ` para *${forModel}*` : "";
  return `Olá, RC iPhones! Tenho interesse no *${p?.model}*${forTxt}${details ? ` (${details})` : ""}${price}${parcel}. Ainda está disponível?`;
};

let lenisRef = null;
export const setLenis = (l) => {
  lenisRef = l;
};
export const pauseScroll = (paused) => (paused ? lenisRef?.stop() : lenisRef?.start());
export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const header = document.querySelector("[data-testid=header-nav]");
  const offset = -((header?.offsetHeight ?? 60) + 12);
  if (lenisRef) {
    lenisRef.resize(); // o Lenis atualiza o limite com atraso; sem isso o destino era cortado em páginas que acabaram de crescer
    lenisRef.scrollTo(el, { offset, immediate: true, force: true });
  } else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY + offset, behavior: "auto" });
};

// Vindo de outra página, mantém a seção no topo enquanto fotos, fontes e listas terminam de carregar.
export const pinToId = (id, ms = 4000) => {
  const go = () => scrollToId(id);
  const events = ["wheel", "touchstart", "keydown", "mousedown"];
  const ro = new ResizeObserver(go);
  let timer;
  const stop = () => {
    ro.disconnect();
    clearTimeout(timer);
    events.forEach((e) => window.removeEventListener(e, stop));
  };
  go();
  ro.observe(document.body);
  events.forEach((e) => window.addEventListener(e, stop, { passive: true }));
  timer = setTimeout(stop, ms);
  return stop;
};
